import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscriber } from 'rxjs';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';

@Component({
  selector: 'app-teacher-profile',
  templateUrl: './teacher-profile.component.html',
  styleUrls: ['./teacher-profile.component.scss']
})
export class TeacherProfileComponent implements OnInit {
  teacherForm: FormGroup;
  collegeList: any;
  filteredCollegeList: any;
  dialogRef: MatDialogRef<any>;
  UserCollege: string;
  DepartmentList: any[];
  filteredDepartmentList: any[];
  filteredmapSubjectList: any;
  mapSubjectList: any;
  saveButton = true
  updateButton = false
  deleteButton: boolean;
  isUgApproval = false;
  isPgApproval = false;
  DesignationList: any;
  filterDesignationList: any;
  GenderList: any;
  filterGenderList: any;
  APIService: any;
  prepopulationId: any
  LoginIDD: any;
  prepopulationDeleteId: any;
  isreaddelete = false;
  isreadupdate = false;
  errormessage: any;
  filename: any;
  fileName: string;
  uploadDocUG: any
  uploadDocPG: any
  uploadDocPhoto: any
  uploadDocSign: any
  fileUploadUGData
  fileUploadPGData
  fileUploadPhotoData
  fileUploadSignata
  FileDataPG: boolean;
  FileDataUG: boolean;
  teacherCreate=true;
teacherUpdate=true;
teacherDelete=true;
  TstatusList: any;
  filterTstatusList: any;
  fcCodeList: any;
  filteredListFcCode: any;
  initialList: any;
  filterinitialList: any;
  TeacherTypeList: any;
  filterTeacherTypeList: any;
  updateButtonDisabled: boolean = false;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService, @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private dialogRef2: MatDialogRef<TeacherProfileComponent>,
    private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl; }
  userPermission: any;
  utp: string;
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission")); 
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      this.userPermission.forEach(element => {
      if(element.PageName == 'Teachers Profile' && (element.PCreate == false || element.PCreate == true))
      {
          this.teacherCreate = false;  
      }
      if(element.PageName == 'Teachers Profile' && element.PUpdate == false)
      {
          this.teacherUpdate = false;  
      }   
      if(element.PageName == 'Teachers Profile' && (element.PDelete == false || element.PDelete == true))
      {
          this.teacherDelete = false;  
      } 
    });
  }
    this.teacherForm = this.fb.group({
      FirstName: new FormControl('', [Validators.required]),
      MiddleName: new FormControl(''),
      LastName: new FormControl('', [Validators.required]),
      FullName: new FormControl(''),
      Email: new FormControl('', [Validators.pattern('(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}')]),
      MobileNo: new FormControl('', [Validators.required,Validators.pattern('(0|91)?[6-9][0-9]{9}')]),
      DeptCode: new FormControl([], [Validators.required]),
      ToughtSubject: new FormControl('', [Validators.required]),
      OSACID: new FormControl(''),
      PGQualiPassYear: new FormControl(''),
      // pgMonth: new FormControl(''),
      ApprovalStPG: new FormControl('', [Validators.required]),
      ApprovalStUG: new FormControl('', [Validators.required]),
      Guide: new FormControl('', [Validators.required]),
      PhdGuide: new FormControl('', [Validators.required]),   
      DOB: new FormControl(''),
      CgCode: new FormControl('', [Validators.required]),
      UGExpYears: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')]),
      UGExpMonths: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')]),
      UGExpDays: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')]),
      PGExpYears: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')]),
      PGExpMonths: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')]),
      PGExpDays: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')]),
      Initial: new FormControl('', [Validators.required]),
      Gender: new FormControl('', [Validators.required]),
      PANNo: new FormControl('', [Validators.pattern('([A-Z]){5}([0-9]){4}([A-Z]){1}$')]),
      AadharNo: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      Debar: new FormControl('', [Validators.required]),
      Designation: new FormControl('', [Validators.required]),
      isHOD: new FormControl('', [Validators.required]),
      //tepm not use
      TeacherPhoto: new FormControl(''),
      TeacherSign: new FormControl(''),
      UGApproval: new FormControl(''),
      PGApproval: new FormControl(''),
      PGExp: new FormControl(''),
      UGExp: new FormControl(''),
      FcCode: new FormControl(''),
      TeacherStatus: new FormControl(''),
      TeacherType: new FormControl(''),
    });
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
    } else {

    }
    this.getCollege();
    this.fetchInitialsList();
    this.fetchDesignationList();
    this.fetchTeacherTypeList();
    this.fetchGenderList();
    this.fetchTeachersStatusList();
    this.fetchFacultyCode();
    this.getDepartment()
  }

  months: string[] = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];


  fetchFacultyCode() {
    this.spinner.show()
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.fcCodeList = res.data;
        this.filteredListFcCode = this.fcCodeList.slice();
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }


  getCollege(item? : string) {
    console.log("yyyyyyyyyyyyyyyyyy");
    
    let payload = {}
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    payload['CgCode'] = this.UserCollege;
    payload['CgType'] = item || this.teacherForm.value.TeacherType;
    this.umsService.getstateCollege(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }  getDepartment(fcCodes?: string[]) {
    this.DepartmentList = [];
    this.filteredDepartmentList = [];
    this.mapSubjectList = [];
    this.filteredmapSubjectList = [];
    let payload = {};
    if (fcCodes && fcCodes.length > 0) {
      payload['FcCode'] = fcCodes.join(',');
    }
    this.umsService.getDeptData(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.DepartmentList = res.data;
        this.filteredDepartmentList = this.DepartmentList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.DepartmentList = [];
    });
  }
  loadSubjectsForDepartments(deptCodes: string[]): void {
    if (!deptCodes || deptCodes.length === 0) {
      this.mapSubjectList = [];
      this.filteredmapSubjectList = [];
      return;
    }

    this.spinner.show();
    const payload = { DeptCode: deptCodes.join(',') };   // comma‑separated string

    this.umsService.getDeptSubData(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data) {
        this.mapSubjectList = res.data;
        this.filteredmapSubjectList = this.mapSubjectList.slice();
      } else {
        this.mapSubjectList = [];
        this.filteredmapSubjectList = [];
      }
    }, (error) => {
      this.spinner.hide();
      console.error('Error loading subjects', error);
      this.mapSubjectList = [];
      this.filteredmapSubjectList = [];
    });
  }
  onDeptChange(): void {
    const selectedDepts = this.teacherForm.get('DeptCode').value;
    this.loadSubjectsForDepartments(selectedDepts || []);
  }
  onFacultyChange(selectedFaculties: any[]) {
    this.teacherForm.patchValue({ DeptCode: [], ToughtSubject: [] });
    this.mapSubjectList = [];
    this.filteredmapSubjectList = [];
    if (selectedFaculties && selectedFaculties.length > 0) {
      this.getDepartment(selectedFaculties);
    } else {

      this.DepartmentList = [];
      this.filteredDepartmentList = [];
    }
  }

  save() {
    if (this.teacherForm.invalid) {
      // this.teacherForm.get('FirstName').markAsTouched();
      // this.teacherForm.get('MiddleName').markAsTouched();
      // this.teacherForm.get('LastName').markAsTouched();
      // this.teacherForm.get('FullName').markAsTouched();
      // this.teacherForm.get('Email').markAsTouched();
      this.teacherForm.get('MobileNo').markAsTouched();
      this.teacherForm.get('DeptCode').markAsTouched();
      this.teacherForm.get('ToughtSubject').markAsTouched();
      this.teacherForm.get('PGQualiPassYear').markAsTouched();
      this.teacherForm.get('ApprovalStPG').markAsTouched();
      this.teacherForm.get('ApprovalStUG').markAsTouched();
      this.teacherForm.get('Guide').markAsTouched();
      this.teacherForm.get('PhdGuide').markAsTouched();
      // this.teacherForm.get('DOB').markAsTouched();
      this.teacherForm.get('CgCode').markAsTouched();
      this.teacherForm.get('UGExpYears').markAsTouched();
      this.teacherForm.get('UGExpMonths').markAsTouched();
      this.teacherForm.get('UGExpDays').markAsTouched();
      this.teacherForm.get('PGExpYears').markAsTouched();
      this.teacherForm.get('PGExpMonths').markAsTouched();
      this.teacherForm.get('PGExpDays').markAsTouched();
      this.teacherForm.get('Initial').markAsTouched();
      this.teacherForm.get('Gender').markAsTouched();
      // this.teacherForm.get('PANNo').markAsTouched();
      // this.teacherForm.get('AadharNo').markAsTouched();
      this.teacherForm.get('Debar').markAsTouched();
      this.teacherForm.get('Designation').markAsTouched();
      this.teacherForm.get('isHOD').markAsTouched();
      this.teacherForm.get('FcCode').markAsTouched();
    }
    else {
      let payload = this.teacherForm.value;
      let toughtSubjectArr = payload.ToughtSubject.join(',');
      payload['ToughtSubject'] = toughtSubjectArr;
      let deptArr = payload.DeptCode.join(',');
      payload['DeptCode'] = deptArr;

      let FcCodeArr = payload.FcCode.join(',');
      payload['FcCode'] = FcCodeArr;
      
      payload['ApprovalDocuments'] = [
        { type: 'UG', file: this.uploadDocUG },
        { type: 'PG', file: this.uploadDocPG },
        { type: 'Photo', file: this.uploadDocPhoto },
        { type: 'Sign', file: this.uploadDocSign },
      ];

      this.umsService.saveTeachersData(payload).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        } else {
          this.spinner.hide();
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      });
    }

  }

  update() {
    if (this.teacherForm.invalid) {
      console.log("hhhhhhhhhhhhhhh",this.teacherForm);
      
      this.teacherForm.get('FirstName').markAsTouched();
      // this.teacherForm.get('MiddleName').markAsTouched();
      this.teacherForm.get('LastName').markAsTouched();
      this.teacherForm.get('FullName').markAsTouched();
      this.teacherForm.get('Email').markAsTouched();
      this.teacherForm.get('MobileNo').markAsTouched();
      this.teacherForm.get('DeptCode').markAsTouched();
      this.teacherForm.get('ToughtSubject').markAsTouched();
      this.teacherForm.get('PGQualiPassYear').markAsTouched();
      this.teacherForm.get('ApprovalStPG').markAsTouched();
      this.teacherForm.get('ApprovalStUG').markAsTouched();
      this.teacherForm.get('Guide').markAsTouched();
      this.teacherForm.get('PhdGuide').markAsTouched();
      // this.teacherForm.get('DOB').markAsTouched();
      this.teacherForm.get('CgCode').markAsTouched();
      this.teacherForm.get('UGExpYears').markAsTouched();
      this.teacherForm.get('UGExpMonths').markAsTouched();
      this.teacherForm.get('UGExpDays').markAsTouched();
      this.teacherForm.get('PGExpYears').markAsTouched();
      this.teacherForm.get('PGExpMonths').markAsTouched();
      this.teacherForm.get('PGExpDays').markAsTouched();
      this.teacherForm.get('Initial').markAsTouched();
      this.teacherForm.get('Gender').markAsTouched();
      this.teacherForm.get('PANNo').markAsTouched();
      // this.teacherForm.get('AadharNo').markAsTouched();
      this.teacherForm.get('Debar').markAsTouched();
      this.teacherForm.get('Designation').markAsTouched();
      this.teacherForm.get('isHOD').markAsTouched();
      this.teacherForm.get('FcCode').markAsTouched();
    }
    else {
      this.spinner.show()
      let payload = this.teacherForm.value;
      let toughtSubjectArr = payload.ToughtSubject.join(',');
      payload['ToughtSubject'] = toughtSubjectArr;
      let deptArr = payload.DeptCode.join(',');
      payload['DeptCode'] = deptArr;
      let FcCodeArr = payload.FcCode.join(',');
      payload['FcCode'] = FcCodeArr;
      payload['TechId'] = this.prepopulationId;
      payload['LoginId'] = this.LoginIDD;
      payload['UserId'] = parseInt(sessionStorage.getItem('userId'));
      payload['TeacherStatus'] = this.teacherForm.value.TeacherStatus;
      payload['ApprovalDocuments'] = [
        { type: 'UG', file: this.uploadDocUG ? this.uploadDocUG : this.fileUploadUGData },
        { type: 'PG', file: this.uploadDocPG ? this.uploadDocPG : this.fileUploadPGData },
        { type: 'Photo', file: this.uploadDocPhoto ? this.uploadDocPhoto : this.fileUploadPhotoData },
        { type: 'Sign', file: this.uploadDocSign ? this.uploadDocSign : this.fileUploadSignata },
      ];
      this.umsService.updateTeachersData(payload).subscribe(res => {

        if (res.status) {
          this.spinner.hide()
          this.updateButtonDisabled = true;
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        } else {
          this.spinner.hide();
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      });
    }

  }


prepopulation(data) {
  this.spinner.show();
  const payload = {};
  payload['TechId'] = data.TechId;
  this.prepopulationId = data.TechId;
  this.LoginIDD = data.LoginId;
  this.isreaddelete = false;
  this.isreadupdate = true;

  this.umsService.getTeachersData(payload).subscribe((res) => {
    const data = res.data[0];
    if (res.status) {
      this.spinner.hide();

      this.saveButton = false;
      this.deleteButton = false;
      this.updateButton = true;
     let appPG;
      if (data.ApprovalStPG == true) {
        this.isPgApproval = true;
        appPG = 1;
        this.FileDataPG = data.PGApproval ? true : false;
      } else {
        this.isPgApproval = false;
        appPG = 0;
        this.FileDataPG = false;
      }

      let appUG;
      if (data.ApprovalStUG == true) {
        this.isUgApproval = true;
        appUG = 1;
        this.FileDataUG = data.UGApproval ? true : false;
      } else {
        this.isUgApproval = false;
        appUG = 0;
        this.FileDataUG = false;
      }

      let Guide = data.Guide ? 1 : 0;
      let PhdGuide = data.PhdGuide ? 1 : 0;
      let Debar = data.Debar ? 1 : 0;
      let isHOD = data.isHOD ? 1 : 0;

    this.fileUploadUGData = data.UGApproval;
      this.fileUploadPGData = data.PGApproval;
      this.fileUploadPhotoData = data.TeacherPhoto;
      this.fileUploadSignata = data.TeacherSign;
      let department = data.DeptCode ? data.DeptCode.split(',') : [];
      let ToughtSubject = data.ToughtSubject ? data.ToughtSubject.split(',') : [];
      let faculty = data.FcCode ? data.FcCode.split(',') : [];
      const loadRemaining = () => {
      this.teacherForm.patchValue({
        FirstName: data.FirstName,
        MiddleName: data.MiddleName,
        LastName: data.LastName,
        FullName: data.FullName,
        DeptCode: department,
        CgCode: data.CgCode,
        MobileNo: data.MobileNo,
        ToughtSubject: ToughtSubject,
        FcCode: faculty,
        Email: data.Email,
        OSACID: data.OSACID,
        Designation: data.Designation,
        PGQualiPassYear: data.PGQualiPassYear,
        ApprovalStPG: appPG,
        ApprovalStUG: appUG,
        Guide: Guide,
        PhdGuide: PhdGuide,
        DOB: data.DOB,
        UGExpYears: data.UGExpYears,
        UGExpMonths: data.UGExpMonths,
        UGExpDays: data.UGExpDays,
        PGExpYears: data.PGExpYears,
        PGExpMonths: data.PGExpMonths,
        PGExpDays: data.PGExpDays,
        Initial: data.Initial,
        Gender: data.Gender,
        PANNo: data.PANNo,
        AadharNo: data.AadharNo,
        Debar: Debar,
        isHOD: isHOD,
        TeacherPhoto: data.TeacherPhoto,
        TeacherSign: data.TeacherSign,
        PGExp: data.PGExp,
        UGExp: data.UGExp,
        TeacherStatus: data.TeacherStatus,
        TeacherType: data.TeacherType
      });
          this.loadSubjectsForDepartments(department);
        };

        if (faculty.length > 0) {
          this.getDepartment(faculty);
          setTimeout(loadRemaining, 500);
        } else {
          this.getDepartment();
          setTimeout(loadRemaining, 500);
     }

    } else {
       this.spinner.hide();
    }
  });
}

prepopulationForDelete(data) {
  this.spinner.show();
  this.isreaddelete = true;
  const payload = {};
  payload['TechId'] = data.TechId;
  this.prepopulationDeleteId = data.TechId;

  this.umsService.getTeachersData(payload).subscribe((res) => {
    const record = res.data[0];
    if (res.status) {
      this.spinner.hide();

      this.saveButton = false;
      this.deleteButton = true;
      this.updateButton = false;

      let appPG = record.ApprovalStPG ? 1 : 0;
      let appUG = record.ApprovalStUG ? 1 : 0;
      let Guide = record.Guide ? 1 : 0;
      let PhdGuide = record.PhdGuide ? 1 : 0;
      let Debar = record.Debar ? 1 : 0;
      let isHOD = record.isHOD ? 1 : 0;

      let department = record.DeptCode ? record.DeptCode.split(',') : [];
      let ToughtSubject = record.ToughtSubject ? record.ToughtSubject.split(',') : [];
      let faculty = record.FcCode ? record.FcCode.split(',') : [];

      if (faculty.length > 0) {
        this.getDepartment(faculty);
      } else {
        this.getDepartment();
      }
  setTimeout(() => {
      this.teacherForm.patchValue({
        FirstName: record.FirstName,
        MiddleName: record.MiddleName,
        LastName: record.LastName,
        FullName: record.FullName,
        DeptCode: department,
        CgCode: record.CgCode,
        MobileNo: record.MobileNo,
        ToughtSubject: ToughtSubject,
        FcCode: faculty,
        Email: record.Email,
        OSACID: record.OSACID,
        Designation: record.Designation,
        PGQualiPassYear: record.PGQualiPassYear,
        ApprovalStPG: appPG,
        ApprovalStUG: appUG,
        Guide: Guide,
        PhdGuide: PhdGuide,
        DOB: record.DOB,
        UGExpYears: record.UGExpYears,
        UGExpMonths: record.UGExpMonths,
        UGExpDays: record.UGExpDays,
        PGExpYears: record.PGExpYears,
        PGExpMonths: record.PGExpMonths,
        PGExpDays: record.PGExpDays,
        Initial: record.Initial,
        Gender: record.Gender,
        PANNo: record.PANNo,
        AadharNo: record.AadharNo,
        Debar: Debar,
        isHOD: isHOD,
        TeacherPhoto: record.TeacherPhoto,
        TeacherSign: record.TeacherSign,
        PGExp: record.PGExp,
        UGExp: record.UGExp,
        TeacherStatus: record.TeacherStatus,
        TeacherType: record.TeacherType
     });
        if (department.length > 0) {
          this.loadSubjectsForDepartments(department);
        }
      }, 500); 

    } else {
      this.spinner.hide();
    }
  });
}


  PgApproval(value) {
    if (value == 1) {
      this.isPgApproval = true
    } else {
      this.isPgApproval = false
    }

  }
  UgApproval(value) {
    if (value == 1) {
      this.isUgApproval = true
    } else {
      this.isUgApproval = false
    }
  }



  fetchDesignationList() {
    const payload = {};
    payload['CdType'] = 'DG';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.DesignationList = res.data;
        this.filterDesignationList = this.DesignationList.slice();
      } else {
      }
    });
  }

  fetchTeacherTypeList() {
    const payload = {};
    payload['CdType'] = 'TEATY';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.TeacherTypeList = res.data;
        this.filterTeacherTypeList = this.TeacherTypeList.slice();
        this.teacherForm.controls['TeacherType'].setValue('IS')
        this.getCollege(this.teacherForm.value.TeacherType);
      } else {
      }
    });
  }


  fetchGenderList() {
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.GenderList = res.data;
        this.filterGenderList = this.GenderList.slice();
      } else {
      }
    });
  }

  fetchInitialsList() {
    const payload = {};
    payload['CdType'] = 'INT';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.initialList = res.data;
        this.filterinitialList = this.initialList.slice();
      } else {
      }
    });
  }


 delete(value: any) {
  this.spinner.show();
  const transformedBody = {
    TechId: this.prepopulationDeleteId,
    FirstName: value.FirstName,
    MiddleName: value.MiddleName,
    LastName: value.LastName,
    FullName: value.FullName,
    Email: value.Email,
    MobileNo: value.MobileNo,
    DeptCode: Array.isArray(value.DeptCode) ? value.DeptCode.join(',') : value.DeptCode,
    ToughtSubject: Array.isArray(value.ToughtSubject) ? value.ToughtSubject.join(',') : value.ToughtSubject,
    FcCode: Array.isArray(value.FcCode) ? value.FcCode.join(',') : value.FcCode,
    OSACID: value.OSACID,
    PGQualiPassYear: value.PGQualiPassYear,
    ApprovalStPG: value.ApprovalStPG,
    ApprovalStUG: value.ApprovalStUG,
    Guide: value.Guide,
    PhdGuide: value.PhdGuide,
    DOB: value.DOB,
    CgCode: value.CgCode,
    UGExpYears: value.UGExpYears,
    UGExpMonths: value.UGExpMonths,
    UGExpDays: value.UGExpDays,
    PGExpYears: value.PGExpYears,
    PGExpMonths: value.PGExpMonths,
    PGExpDays: value.PGExpDays,
    Initial: value.Initial,
    Gender: value.Gender,
    PANNo: value.PANNo,
    AadharNo: value.AadharNo,
    Debar: value.Debar,
    Designation: value.Designation,
    isHOD: value.isHOD,
    TeacherStatus: value.TeacherStatus,
    TeacherType: value.TeacherType,
    TeacherPhoto: value.TeacherPhoto || "",
    TeacherSign: value.TeacherSign || "",
    UGApproval: value.UGApproval || "",
    PGApproval: value.PGApproval || "",
    PGExp: value.PGExp || "",
    UGExp: value.UGExp || "",
    LoginId: value.LoginId || 71436,     
    UserId: value.UserId || 72,          
    ApprovalDocuments: value.ApprovalDocuments || [
      { type: "UG", file: "" },
      { type: "PG", file: "" },
      { type: "Photo", file: "" },
      { type: "Sign", file: "" }
    ]
  };
  const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    body: transformedBody
  };

  this.httpClient.delete(this.APIService + '/supervisor/TeacherProfile', options)
    .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close();
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close();
        });
      });
  }

  DeletetheRecord() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.delete(this.teacherForm.value);
        this.dialogRef2.close();
      } else {
        this.dialogRef2.close();
      }
    });
  }

  fileUploads: string[] = [];

  UGApproval($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    this.filename = '';  // Clear the filename
    // this.fileUploadData = '';
    // this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }
  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDocUG = d;

    });
  }
  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  PGApproval($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    this.filename = '';  // Clear the filename
    // this.fileUploadData = '';
    // this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64_2(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }
  convertToBase64_2(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile2(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDocPG = d;

    });
  }
  readFile2(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  TeacherPhoto($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    this.filename = '';  // Clear the filename
    // this.fileUploadData = '';
    // this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64_TeacherPhoto(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }
  convertToBase64_TeacherPhoto(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile_TeacherPhoto(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDocPhoto = d;

    });
  }
  readFile_TeacherPhoto(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  TeacherSign($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    this.filename = '';  // Clear the filename
    // this.fileUploadData = '';
    // this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64_TeacherSign(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }
  convertToBase64_TeacherSign(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile_TeacherSign(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDocSign = d;

    });
  }
  readFile_TeacherSign(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }


  showbaseUGFile() {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.fileUploadUGData,
        disableClose: true
      });
  }
  showbasePGFile() {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.fileUploadPGData,
        disableClose: true
      });
  }
  showbasePhotoFile() {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.fileUploadPhotoData,
        disableClose: true
      });
  }
  showbaseSignFile() {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.fileUploadSignata,
        disableClose: true
      });
  }


  
  fetchTeachersStatusList() {
    const payload = {};
    payload['CdType'] = 'TS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.TstatusList = res.data;
        this.filterTstatusList = this.TstatusList.slice();
      } else {
      }
    });
  }

}